import { UrlPattern } from '../formValidation'

export const addHttp = (url: string): string => {
  if (!UrlPattern.test(url)) {
    return 'http://' + url
  }
  return url
}

export const isHttp = (url: string): boolean => {
  return UrlPattern.test(url)
}
